import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const EditLeadCreditData = (props) => {
  const [agreement, setAgreement] = useState(props.leadData.creditAgreement);
  const [agreementDB, setAgreementDB] = useState([]);
  const [ammount, setAmmount] = useState(props.leadData.creditAmmount);
  const [currency, setCurrency] = useState(props.leadData.creditCurrency);
  const [date, setDate] = useState(props.leadData.creditDate);
  const [length, setLength] = useState(props.leadData.creditLength);
  const [end, setEnd] = useState(props.leadData.creditEnd);
  const [loading, setLoading] = useState(false);

  const fetchSellAgreement = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellAgreement", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setAgreementDB(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchSellAgreement();
  };

  useEffect(() => {
    getData();
  }, []);

  const editLead = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        leadId: props.leadData.id,
        agreement: agreement,
        ammount: ammount,
        currency: currency,
        date: date,
        length: length,
        end: end,
      };

      await fetch("https://apidevkppp.ftpeople.pl/updateLeadCreditData", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano dane kredytu: " + props.user,
        props.leadData.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "lead",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validatePayment = (e) => {
    return true;
    if (
      ammount > 0 &&
      currency.length > 0 &&
      date.length > 0 &&
      length.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div
              style={{ width: "49%", minWidth: "49%" }}
              className="inputCol_2"
            >
              <label>Kwota kredytu</label>
              <input
                style={{ boxSizing: "border-box" }}
                type="number"
                id="name"
                name="name"
                value={ammount}
                onChange={(e) => {
                  setAmmount(e.target.value);
                }}
                onKeyPress={checkDigit}
              />
            </div>

            <div
              style={{ width: "49%", minWidth: "49%" }}
              className="inputCol_2"
            >
              <label>Waluta kredytu</label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={currency}
                onChange={(e) => {
                  setCurrency(e.target.value);
                }}
              >
                {!currency ? (
                  <>
                    <option key={0} value={0}>
                      Wybierz...
                    </option>
                  </>
                ) : (
                  ""
                )}
                <option key={0} value={"PLN"}>
                  PLN
                </option>
                <option key={1} value={"CHF"}>
                  CHF
                </option>
              </select>
            </div>
          </div>
          <div className="inputBox">
            <div
              style={{ width: "49%", minWidth: "49%" }}
              className="inputCol_2"
            >
              <label>Data kredytu</label>
              <input
                style={{ boxSizing: "border-box" }}
                type="date"
                id="name"
                name="name"
                value={date}
                onChange={(e) => {
                  setDate(e.target.value);
                }}
              />
            </div>
            <div
              style={{ width: "49%", minWidth: "49%" }}
              className="inputCol_2"
            >
              <label>Długość kredytu</label>
              <input
                style={{ boxSizing: "border-box" }}
                type="number"
                id="name"
                name="name"
                value={length}
                onChange={(e) => {
                  setLength(e.target.value);
                }}
                onKeyPress={checkDigit}
              />
            </div>
          </div>

          <div className="inputBox">
            <div
              style={{ width: "55%", minWidth: "55%" }}
              className="inputCol_2"
            >
              <label>Data zakończenia kredytu</label>
              <input
                style={{ boxSizing: "border-box" }}
                type="date"
                id="name"
                name="name"
                value={end}
                onChange={(e) => {
                  setEnd(e.target.value);
                }}
              />
            </div>
            <div
              style={{ width: "49%", minWidth: "49%" }}
              className="inputCol_2"
            ></div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editLead}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditLeadCreditData;
